import type { QuoteCollaboratorsListResponse } from './api';

export const normalizeQuoteCollaboratorsList = (list: QuoteCollaboratorsListResponse) => {
  if (!list) {
    return [];
  }
  return list;
};
